import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-ok-erfassen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeOkErfassenEffects {

    AufgabeOkErfassen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_OK_ERFASSEN),
        mergeMap((x: ac.PostAufgabeOkErfassenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeOkErfassen(x.aufgabeRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeOkErfassenErfolgreichAction(result, x.aufgabeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeOkErfassenFehlerAction(error, x.aufgabeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
